import React, { useContext, useRef, useEffect } from "react";
import { Icon } from "@iconify/react";

import { useLanguageVisibility } from "./hooks/use-language-visibility";
import { store } from "../Store";
import { DropdownLang } from "./dropdown-lang";
import { useLanguage } from "../../hooks/use-language";
import { useTranslationsById } from "../../hooks/use-translations-by-id";

/**
 * Rederiza el boton de lenguaje en el Header
 * @returns {React.Component}
 */
export const LangButton = () => {
    const languageVisibility = useLanguageVisibility();
    const globalState = useContext(store);
    const isAuth = globalState?.state?.sesionActiva === "SI";
    const language = useLanguage();
    const texts = useTranslationsById({ mainSectionName: "header", language: language });

    const langRef = useRef(null);

    const handleVisibility = () => {
        if (languageVisibility.isVisible) {
            languageVisibility.hide();
        }
        else {
            languageVisibility.show();
        }
    }

    /**Función que permite cerrar el dropdown dando click fuera de él*/
      useEffect(() => {
        let handler = (e) => {
          if ( !langRef.current.contains(e.target)) {
            languageVisibility.hide();
          }
        }
        document.addEventListener("mousedown", handler);
    
        return () => {
          document.removeEventListener("mousedown", handler)
        }
      }, [])

    return (
        <div ref={langRef}>
            <button
                className={`${isAuth ?
                    languageVisibility.isVisible ? 
                      "relative lang icon-button ml-1 activeMode" 
                      :
                      "relative lang icon-button ml-1" 
                  :
                    languageVisibility.isVisible ? 
                      "relative lang icon-button icon-responsive ml-1 activeMode" 
                      : 
                      "relative lang icon-button icon-responsive ml-1"
                } focusable-red`}
                onClick={() => { handleVisibility(); }}
                style={{fontWeight: 700}}
                aria-label={texts?.getText({ id: "button_languages_description", defaultText: "Abrir la lista desplegable de idiomas seleccionables"}) }
            >
                {language === "es" ? 'ES' : 'EN'}
                <Icon icon="material-symbols:keyboard-arrow-down-rounded" width={25} height={25} className="icon-down ml-0"/>
            </button>

            <DropdownLang visibility={handleVisibility}/>
        </div>

    )
}